"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./resident-detail-dto");
class IluAdmissionDto {
}
exports.IluAdmissionDto = IluAdmissionDto;
